import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
} from "@mui/material";
import {
  TextField,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const NewParagraphDocModal = ({ value, onSave, isOpen, onClose }) => {
  const [stateData, setStateData] = React.useState(value ? value : "");

  useEffect(() => {
    setStateData(value ? value : "");
  }, [isOpen]);

  const handleChangeValue = (e) => {
    const dataTemp = e.target.value;
    setStateData(dataTemp);
  };
  const handleSave = () => {
    onSave(stateData);
    onClose();
  };
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        zIndex: 1000,
        "& .MuiDialogContent-root": {
          padding: 2,
        },
        "& .MuiDialogActions-root": {
          padding: 2,
        },
        "& .MuiPaper-root.MuiDialog-paper": {
          minWidth: "800px",
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Edito Paragraf
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <textarea
          value={stateData}
          onChange={handleChangeValue}
          style={{
            width: "100%",
            fontStyle: "Arial",
            fontSize: "16px",
            padding: "6px",
            borderRadius: "8px",
            minHeight: "80px",
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          fullWidth
        >
          Ruaj
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewParagraphDocModal;
